module.exports = __webpack_public_path__ + "img/gfsph.769d4055.png";